// extracted by mini-css-extract-plugin
export default {"cardMedia":"UV-z","shopText":"VV-z","videoPlayer":"WV-z","videoContainer":"XV-z"};